<div>
    <aumico-users-registration
        [countries]="countries"
        (registrationFormStatus)="onRegisterFormStatusChange($event)"
        (registrationData)="onRegisterFormValueChange($event)"
        (pricesClicked)="openPricesLink()"
        (privacyPolicyClicked)="openPrivacyPolicyLink()"
        (termsAndConditionsClicked)="openTermsAndConditionsLink()"
        (agreementOnOrderDataProcessingClicked)="openAgreementOnOrderDataProcessingLink()"
    ></aumico-users-registration>
    <div class="continue-button" style="margin-top: 32px">
        <ham-button [disabled]="!isRegisterFormValid" (buttonClick)="createAccount()">
            <span *ngIf="!isCreateAccountButtonClicked"
                >{{localizations.aumico_reports_registration_create_account_button| i18next}}</span
            >
            <span *ngIf="isCreateAccountButtonClicked"
                >{{localizations.aumico_users_signup_creating_your_account_button| i18next}}</span
            >
        </ham-button>
    </div>
</div>

<mat-error *ngIf="backendError">{{localizations.aumico_errors_server_error| i18next}}</mat-error>
<mat-error *ngIf="userEmailAlreadyExist">{{localizations.aumico_errors_server_error| i18next}}</mat-error>
